module.exports = __webpack_public_path__ + "media/teacher/components/GetStarted/images/PT G2-1f95b12c4499d91a4fdef8028a59975b.gif";